import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function PsflineContentReducer(state = initialState.psflineContent, action: any) {
  switch (action.type) {
    case types.SAVE_PSFLINECONTENT_SUCCESS:
      return action.psflineContent;
    default:
      return state;
  }
}
